// V42 — Custom booking-form questions. Admins pick questions per Event Type;
// answers are saved into the lead's custom_fields and shown in lead details.

// Presets prefill label / type / options when adding a question.
export const QUESTION_PRESETS = [
  { preset: 'trimester', key: 'trimester', label: 'Trimester', type: 'select', options: ['Trimester 1', 'Trimester 2', 'Trimester 3'] },
  { preset: 'pregnancy_week', key: 'pregnancy_week', label: 'Pregnancy Week', type: 'number', options: [] },
  { preset: 'due_date', key: 'due_date', label: 'Due Date', type: 'date', options: [] },
  { preset: 'stage', key: 'stage', label: 'Stage', type: 'select', options: ['Trying to Conceive', 'Prenatal', 'Postnatal'] },
  { preset: 'referral_source', key: 'referral_source', label: 'How did you hear about us?', type: 'select', options: ['Instagram', 'Facebook', 'Google', 'Friend / Family', 'Doctor', 'Other'] },
  { preset: 'concern', key: 'concern', label: 'Main concern', type: 'text', options: [] },
  { preset: 'custom', key: '', label: '', type: 'text', options: [] },
];

export const QUESTION_TYPES = [
  { value: 'select', label: 'Dropdown' },
  { value: 'text', label: 'Text' },
  { value: 'number', label: 'Number' },
  { value: 'date', label: 'Date' },
];

export const slugifyKey = (label) =>
  (label || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '') || `q_${Date.now()}`;
